export const clickEvent = event => {
  if (event.keyCode === 13) {
    event.preventDefault();
    event.target.click();
  }
};



// WEBPACK FOOTER //
// ./src/utils/adaConfigurations/customEvents.js